import { createFileRoute } from '@tanstack/react-router';
// Will be lazy loaded from MFE
export const Route = createFileRoute('/org/$organization/$project/$application/settings/deployment-integrations')({
    component: ()=>null
});
